<template>
  <article class="rules-art">
    <group gutter="0">
      <cell title="立新车市车辆拍卖服务协议" class="title">
      </cell>
      <cell>
        <div slot="after-title" class="content">为使用立新车市保证金拍卖服务，您应当阅读并遵守《立新车市车辆拍卖服务协议》（以下简称”协议”）。<br>请您务必审慎阅读且充分理解各条款内容，当您成功出价即视为同意并接受本平台的竞拍服务协议。</div>
      </cell>
     <cell title="【具体协议】"  class="no-line">
       <div slot="after-title" class="content fc-black fs15">一、拍卖规则：</div>
       <div slot="after-title" class="content">您对竞拍车源的最后出价即为意愿成交价格。若看车时未出现车况降级，则不可进行线下议价；若您违约，将被扣除相应保证金。为了保障您的利益，请谨慎出价。<br>每次竞拍的加价次数不限，每次出价必须大于当前最高价，加价幅度必须是整百。</div>
       <div slot="after-title" class="content"><span class="fc-black">时间规则：</span>竞拍初始时间为120秒，超过保留价后出价最高者竞拍成功。</div>
       <div slot="after-title" class="content">（1）在120秒内没有人出价，即结束。 </div>
       <div slot="after-title" class="content">（2）120秒内的最后20秒内有人出价则自动延至20秒，即100秒＜出价时间＜120秒，拍卖延至20秒。</div>
       <div slot="after-title" class="content">（3）在第100秒开始，每次出价则重新延至20秒。</div>
     </cell>
     <cell title="二、保证金规则："  class="no-line">
       <div slot="after-title" class="content">保证金用于保障交易的公平诚信而设立。</div>
       <div slot="after-title" class="content"><span class="fc-black">保证金冻结规则：</span>当您有正在竞拍出价或中标交易中的车辆时，每台车辆将被冻结2000元作为该车的交易保证金。冻结的金额为不可用余额，不能提取。</div>
       <div slot="after-title" class="content"><span class="fc-black">保证金解冻规则：</span>当您参与竞拍出价的车辆未中标时，您的保证金将立即解冻。当您参与出价的车辆中标时，若您已付车款，则保证金在交易成功后由卖家操作解冻；若您未付车款，则保证金需要与卖家沟通协商来定是解冻保证金或是扣罚保证金。</div>
     </cell>
      <cell title="三、成交规则：" class="no-line">
       <div slot="after-title" class="content">竞拍结束时，当您的出价为最高价且达到卖家设置的保留价时，系统会以最高价自动成交；若未达到卖家设置的保留价时，则自动未成交。</div>
       <div slot="after-title" class="content">付款交易完成后，本平台将向您即时收取500元/台的信息服务费。</div>
     </cell>
      <cell title="四、线下交易规则" class="no-line">
        <div slot="after-title" class="content">（1）如您已成功中标，请在中标后24小时内在线下与卖家完成付款交易。</div>
        <div slot="after-title" class="content">（2）请您务必在卖家指定的时间内完成过户手续。</div>
      </cell>
      <cell title="五、争议处理规则" class="no-line">
        <div slot="after-title" class="content">验车过户、及提车等售后问题属卖家、买家线下沟通环节，双方务必本着公平高效的原则及时沟通，公平交易。</div>
        <div slot="after-title" class="content">如有异议可反馈至平台，平台运营人员会进行调查沟通并予以答复。</div>
      </cell>
      <cell title="六、不具争议项目规则" class="no-line">
        <div slot="after-title" class="content">本平台不接受以下项目导致的争议：</div>
        <div slot="after-title" class="content">（1）车辆非核心配件的原、副厂属性及修复历史（例：车身外观所有塑料配件）。</div>
        <div slot="after-title" class="content">（2）车辆配置是否原车还是后期加装属性。</div>
        <div slot="after-title" class="content">（3）本平台只支持卖家对其所售车辆的骨架、外观、内饰、发动机、变速箱重点损伤予以描述，不再过多表述瑕疵项，如遇车辆与报告不符，本平台只接受骨架重点损伤未表述的争议情况。除此外的其他任何不符状况，本平台不做任何形式的承诺和补偿议价，请买家谨慎出价。</div>
        <div slot="after-title" class="content">（4）车辆玻璃及天窗玻璃，只表述当前状况，不做是否原车检测。</div>
        <div slot="after-title" class="content">（5）车辆公里数只记录当前仪表显示里程，不做实际行驶里程检测。</div>
        <div slot="after-title" class="content">（6）车辆刹车盘、刹车片、地胶、脚垫、消音器、燃油表、水温表。</div>
        <div slot="after-title" class="content">（7）车辆可抛光去除的所有损伤。</div>
        <div slot="after-title" class="content">（8）车辆排放标准依据车辆当前户籍所在地标准执行，不接受除当前户籍所在地外其他区域查询结果差异导致的争议。</div>
      </cell>
      <cell title="七、风险告知提示" class="no-line">
        <div slot="after-title" class="content">立新车市对平台的车辆状况、参数指标、零配件、车辆状态均不具备审查责任。车商需自行评估拍卖车辆的状况。车商与其他用户（如4S店）产生的交易纠纷，由车商与其他用户（如4S店）自行协商处理。</div>
      </cell>
    </group>
  </article>
</template>
<script>
import { Cell, Group } from '@lx-frontend/cvux'
export default {
  components: {
    Cell,
    Group
  }
}
</script>
<style rel="stylesheet/less" lang="less">
  .rules-art{ min-height: 100%; background: #fff; overflow-x: hidden;
    .title{ line-height: 24px;}
    .content{ line-height: 20px; color: #5d5d5d; font-size: 0.34667rem; padding-bottom: 2px;}
    /*.content:first-child{ padding-bottom: 10px;}*/
    .weui_cell.no-line:before{ display: none}
    .fc-black{ color: #000;}
    .fs15{ font-size: 15px;}
  }
</style>
